export enum CommonType {
    Yes = 'yes',
    No = 'no',
    DontKnow = 'dontKnow',
    True = 'true',
    False = 'false',
    Success = 'success',
    Failed = 'failed',
    Other = 'other',
    Unknown = 'unknown',
    All = 'all',
}
